export enum ButtonVariant {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  LINK = 'link'
}

export enum ButtonColor {
  PRIMARY = 'primary',
  POSITIVE = 'positive',
  NEGATIVE = 'negative',
  WARNING = 'warning',
  INFO = 'info',
  NEUTRAL_LIGHT = 'neutral-light',
  NEUTRAL_DARK = 'neutral-dark',
  BRIGHT = 'bright'
}

export enum ButtonScale {
  LARGE = 'large',
  NORMAL = 'normal',
  SMALL = 'small',
  EXTRA_SMALL = 'extra-small',
  SUPER_SMALL = 'super-small',
}

export enum ButtonIconPosition {
  LEFT = 'left',
  RIGHT = 'right'
}